import { BoxedViewProvider } from './BoxedViewContext';
import { FontSizeProvider } from './FontSizeContext';
import { ThemeProvider } from './ThemeContext';
import PropTypes from 'prop-types';
import { ShortcutProvider } from './ShortcutProvider';
import { AuthProvider } from './AuthProvider';

export const ContextProvider = ({ children }) => {
   return (
      <ShortcutProvider>
         <BoxedViewProvider>
            <ThemeProvider>
               <FontSizeProvider>
                  <AuthProvider>{children}</AuthProvider>
               </FontSizeProvider>
            </ThemeProvider>
         </BoxedViewProvider>
      </ShortcutProvider>
   );
};

ContextProvider.propTypes = {
   children: PropTypes.node.isRequired,
};
